import { type GiftCardSectionCreate } from '../../../types'

export const createGiftCardData = (): GiftCardSectionCreate => {
  return {
    data: null,
    type: 'gift-card',
  }
}
